import styled from "@emotion/styled";

const ProductsGrid = styled.div<{
  hideCategoryTree?: boolean;
}>`
  display: grid;
  grid-template-columns: ${({ hideCategoryTree }) =>
    hideCategoryTree ? "repeat(4, 1fr)" : "repeat(3, 1fr)"};
  grid-gap: ${({ theme }) => theme.space.space24};
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints?.md}) {
    grid-template-columns: ${({ hideCategoryTree }) =>
      hideCategoryTree ? "repeat(4, 1fr)" : "repeat(3, 1fr)"};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints?.sm}) {
    grid-template-columns: repeat(2, minmax(136px, 1fr));
    grid-gap: ${({ theme }) => theme.space.space24}
      ${({ theme }) => theme.space.space8};
  }
`;

export default ProductsGrid;
